import Tooltip from "@mui/material/Tooltip";
import {IconButton, Link, useTheme} from "@mui/material";
import React from "react";
import {Media} from "../../types/types";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import {getAssetDownloadUrl} from "../../common/helpers";
import {OverlayButton} from "../Common/OverlayButton";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

interface FileDownloadMenuProps {
    isInOverlay?: boolean,
    media: Media | undefined,
    locale: string,
}

const FileDownloadMenu = ({isInOverlay = false, media, locale}: FileDownloadMenuProps) => {
    
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [calculatedWidth, setCalculatedWidth] = React.useState(0);

    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setCalculatedWidth(event.currentTarget && event.currentTarget.offsetWidth);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const isMenuOpen = !!anchorEl;

    const theme = useTheme();

    if (!media) {
        return null;
    }

    return <>
        <Tooltip title="View download options" sx={{zIndex: 99999}}>
            {isInOverlay ? (
                <OverlayButton
                    aria-label="view download options"
                    onClick={handleOpenMenu}
                    endIcon={isMenuOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    sx={{pl: theme.spacing(2), ml: theme.spacing(3)}}
                >
                    Download
                </OverlayButton>
            ) : (
                <IconButton
                    aria-label="view download options"
                    disableRipple
                    onClick={handleOpenMenu}
                    sx={{...{marginBottom: "auto"}, ...(isInOverlay ? {color: "white", zIndex: 99998} : {})}}
                >
                    <FileDownloadIcon/>
                </IconButton>
            )}
        </Tooltip>
        <Menu
            sx={{...{mt: "45px", minWidth: anchorEl && anchorEl.offsetWidth }, ...(isInOverlay ? {color: "white", zIndex: 99999} : {})}}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={isMenuOpen}
            onClose={handleCloseMenu}
        >
            {Object.keys(media).filter(item => item !== "thumbnail").map((value, index) => (
                <MenuItem key={index} sx={{minWidth: `${calculatedWidth}px` }}>
                    <Link
                        download
                        href={getAssetDownloadUrl(media[value]!.path!)}
                        underline="none"
                        sx={{color: theme.palette.text.secondary}}
                    >
                        {media[value]!.labels?.[locale] || media[value]!.labels?.["en-US"]}
                    </Link>
                </MenuItem>
            ))}
        </Menu>

    </>;
}

export default FileDownloadMenu;